export default __webpack_public_path__ + "static/media/bg-garantia-produto.30adb15a.webp";